'use client';

import { GlobalPagePropsContext } from '@contexts/GlobalPagePropsContext';
import { IServerPagePropsDecodeState } from '@wconcept/wconcept-common/models/display';
import { getAppVesrion } from '@wconcept/wconcept-common/utils/userAgentUtil';
import { decompress } from 'lz-string';
import { useContext, useMemo } from 'react';

function useGlobalState<T>() {
  const {
    isMobile,
    assistData,
    decodedAssistData,
    myHeartList,
    myFollowList,
    domainGender,
    initialData,
    deviceInfo,
    mode,
    appInfo,
    pageInfo,
    isStatic,
    seoMeta,
    datadogProperty,
    addMyHeartProductItem,
    deleteMyHeartProdcutItem,
    addMyHeartBrandItem,
    deleteMyHeartBrandItem,
    addMyHeartContentItem,
    deleteMyHeartContentItem,
    setContentsMyHeart,
    setProductMyHeart,
    setBrandMyHeart,
    findContent,
    setFollowIds,
    addFollowId,
    deleteFollowId,
  } = useContext(GlobalPagePropsContext);

  const resolvedAssistData = useMemo(
    () =>
      decodedAssistData ?? {
        ...assistData,
        user: JSON.parse(decompress(assistData.user)),
      },
    [decodedAssistData, assistData]
  );

  return {
    datadogProperty,
    isMobile,
    deviceInfo: {
      ...deviceInfo,
      version:
        typeof window !== 'undefined'
          ? getAppVesrion(window.navigator.userAgent)
          : deviceInfo?.version,
    },
    assistData: resolvedAssistData,
    myHeartList,
    myFollowList,
    domainGender,
    initialData,
    mode,
    appInfo,
    pageInfo,
    isStatic,
    seoMeta,
    findContent,
    addMyHeartProductItem,
    deleteMyHeartProdcutItem,
    addMyHeartBrandItem,
    deleteMyHeartBrandItem,
    addMyHeartContentItem,
    deleteMyHeartContentItem,
    setContentsMyHeart,
    setProductMyHeart,
    setBrandMyHeart,
    setFollowIds,
    addFollowId,
    deleteFollowId,
  } as IServerPagePropsDecodeState<T>;
}

export default useGlobalState;
